import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const sentinel = document.getElementById('cta-sentinel');
      if (!sentinel) return;
      setVisible(sentinel.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 px-3 pb-3 transition-[opacity,transform] duration-200 ease-out ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-6 opacity-0'}`} data-id="element-29" data-mp="2aw36ch6yijn5">
      <div className="mx-auto max-w-md" data-id="element-30" data-mp="33jgx1xk2aiyt">
        <a href={CHECKOUT_URL} className="flex animate-shake items-center justify-center gap-2 rounded-2xl bg-forest-mid px-4 py-4 text-center text-[15px] font-extrabold uppercase tracking-wide text-white shadow-[0_10px_30px_rgba(10,58,36,0.35)] ring-4 ring-forest-mid/25 transition-colors duration-150 ease-out hover:bg-forest" data-id="element-31" data-mp="33ifllrz4vugk">
          Get the Clinical Kit — $27
          <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-32" data-mp="2u8wcmm5vinwv" />
        </a>
      </div>
    </div>;
}